export const SW_VERSIONS: string[] = [
  "4.8",
  "4.5",
  "4.3",
];

